// extracted by mini-css-extract-plugin
module.exports = {"banner_container":"style_banner_container__2hrvU","banner_title":"style_banner_title__pmS4a"};